import styled from 'styled-components';
import { Form } from '../../../style/FormEditAccount.style';

export const EmailFormBox = styled(Form)`

    margin: 0;

    justify-content: space-between;
`;
